export default __webpack_public_path__ + "static/media/Assembly_Instructions_Aug-28-2023.3296fc65.pdf";